import React from "react";
import { Typography } from "@mui/material";

export  function NavbarSimple() {
  return (
    <nav className="w-screensticky top-0 z-50 bg-gradient-to-r from-[#324130] via-[#324130] to-[#92843B] text-white border-b border-white/10">
      <div className="mx-auto px-3 md:px-6" style={{ marginLeft: '-2.55%' }}>

        {/* Top row: left logo + nav menu */}
        <div className="flex items-center justify-center h-10 gap-2" style={{ width: '100%', marginTop: '1%' }}>
          {/* Left main logo */}
         
            <img
              src="./assets/exp_caminos.png"
              alt="Experimentando Caminos"
              className="h-10 w-auto "
              style={{ height: '15vh', marginTop: '1%' }} // Adjust width for responsiveness
            />


                 
{/*             <Typography variant="subtitle2" className="font-extrabold uppercase mb-0.5">
              Realización:
            </Typography> */}
            <a
              href="https://www.redus.org.br/foro-de-ciudades-amazonicas"
              target="_blank"
              className="block"
            >
              <img
                src="./assets/colorclaro_horizontal.png"
                alt="Foro de Ciudades Amazónicas"
                className="h-7 w-auto object-contain"
                style={{ height: '15vh', marginTop: '2.5%' }} // Adjust width for responsiveness
              />
            </a>


          {/* 2) Implementación */}
        
{/*             <Typography variant="subtitle2" className="font-extrabold uppercase mb-0.5">
              Implementación:
            </Typography> */}
            <img
              src="./assets/geo_adaptive.png"
              alt="GeoAdaptive"
              className="h-9 w-auto object-contain"
              style={{ height: '10vh', marginTop: '1%' }}
            />

          {/* 3) Apoyo técnico y financiero */}
         
{/*             <Typography variant="subtitle2" className="font-extrabold uppercase mb-0.5 text-center">
              Apoyo técnico y financiero:
            </Typography> */}
            <div className="flex items-center gap-1">
              <img
                src="./assets/amazonia.png"
                alt="Amazonía Siempre"
                className="h-9 w-auto object-contain"
                style={{ height: '7.5vh', marginTop: '2%' }}
              />
              <img
                src="./assets/bid.png"
                alt="BID"
                className="h-9 w-auto object-contain"
                style={{ height: '10vh', marginTop: '2%' }}
              />
            </div>


          {/* Menu links */}
          
        </div>

        {/* Second row: three groups of partners */}

      </div>
    </nav>
  );
}

export default function Navbar() {
  return (
    <nav className="sticky top-0 z-50 bg-gradient-to-r from-[#324130] via-[#324130] to-[#92843B] text-white border-b border-white/10 display-flex " style={{ display: 'flex', justifyItems: 'space-between', height: '6%' }}>
      <div className="mx-auto px-3 md:px-3" style={{ marginLeft: '0%' }}>

        {/* Top row: left logo + nav menu */}
        <div className="flex items-center justify-around h-10 gap-10" style={{ width: '100%', marginTop: '1%' }}>
          {/* Left main logo */}
         
            <img
              src="./assets/exp_caminos.png"
              alt="Experimentando Caminos"
              className="w-auto "
              style={{ height: '3.5vh', marginTop: '5%', marginBottom: '5%' }} // Adjust width for responsiveness
            />


                 
{/*             <Typography variant="subtitle2" className="font-extrabold uppercase mb-0.5">
              Realización:
            </Typography> */}
            <a
              href="https://www.redus.org.br/foro-de-ciudades-amazonicas"
              target="_blank"
              className="block"
            >
              <img
                src="./assets/colorclaro_horizontal.png"
                alt="Foro de Ciudades Amazónicas"
                className="w-auto object-contain"
                style={{ height: '3.25vh', marginTop: '2.5%', marginBottom: '5%', marginLeft: '3.5%' }} // Adjust width for responsiveness
              />
            </a>


          {/* 2) Implementación */}
        
{/*             <Typography variant="subtitle2" className="font-extrabold uppercase mb-0.5">
              Implementación:
            </Typography> */}
            <img
              src="./assets/geo_adaptive.png"
              alt="GeoAdaptive"
              className=" w-auto object-contain"
              style={{ height: '4.5vh', marginTop: '5%', marginBottom: '5%', marginRight: '0.5%' }}
            />

            <img
                src="./assets/amazonia.png"
                alt="Amazonía Siempre"
                className=" w-auto object-contain"
                style={{ height: '4.5vh', marginTop: '5%', marginBottom: '5%' }}
              />
              <img
                src="./assets/bid.png"
                alt="BID"
                className="w-auto object-contain"
                style={{ height: '4vh', marginTop: '5%', marginBottom: '5%' }}
              />
          
        </div>

        {/* Second row: three groups of partners */}

      </div>
      <div className="flex items-center justify-center h-10">
        <ul className="flex items-right gap-10 md:gap-10 mr-10 mt-[2.5%]">
            <li><a href="#contexto" className="text-lg  font-bold hover:text-gray-200">Contexto</a></li>
            <li><a href="#uso-suelo" className="text-lg font-bold hover:text-gray-200">Uso de Suelo</a></li>
            <li><a href="#emisiones-carbono" className="text-lg font-bold hover:text-gray-200">Emisiones de Carbono</a></li>
            <li><a href="#escenarios" className="text-lg font-bold hover:text-gray-200">Escenarios</a></li>
          </ul>
      </div>
    </nav>
  );
}